var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBredArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.73057L5.63731 7.24352L0.124352 12.8394L1.32642 14L8 7.20207L1.16062 0.528496L0 1.73057Z",
    fill: "#F9FAFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBredArrow);
export default __webpack_public_path__ + "static/media/bred-arrow.d620e053f6f4789e7fa17e7bbbbb915f.svg";
export { ForwardRef as ReactComponent };